"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _arrow = _interopRequireDefault(require("./arrow.svg"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var LeftArrow = _styledComponents["default"].img.withConfig({
  displayName: "arrows__LeftArrow",
  componentId: "sc-1xfaeh9-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    opacity: 0.2;\n    transition: opacity 0.2s ease-in;\n    height: ", ";\n    width: ", ";\n    cursor: pointer;\n\n    &:hover {\n        opacity: 1;\n    }\n    @media (max-width: 640px) {\n        display: none;\n    }\n"])), function (_ref) {
  var height = _ref.height;
  return height;
}, function (_ref2) {
  var width = _ref2.width;
  return width;
});

var RightArrow = (0, _styledComponents["default"])(LeftArrow).withConfig({
  displayName: "arrows__RightArrow",
  componentId: "sc-1xfaeh9-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    left: 0;\n    right: ", ";\n    transform: scaleX(-1);\n"])), function (_ref3) {
  var distance = _ref3.distance;
  return "calc(".concat(distance, " / -2)");
});

var Container = _styledComponents["default"].div.withConfig({
  displayName: "arrows__Container",
  componentId: "sc-1xfaeh9-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    justify-content: space-between;\n    position: absolute;\n    z-index: 3;\n    pointer-events: none;\n    \n    ", "\n\n    ", "\n"])), function (_ref4) {
  var visibleCardWidth = _ref4.visibleCardWidth;
  return visibleCardWidth ? "@media(max-width: ".concat(visibleCardWidth, "px) {display: none;}") : null;
}, function (_ref5) {
  var vertical = _ref5.vertical,
      height = _ref5.height,
      distance = _ref5.distance;
  return vertical ? "\n            width: ".concat(height, ";\n            height: calc(100% + ").concat(distance, ");\n            left: calc(50% - ").concat(height, " / 2);\n            top: calc(").concat(distance, " / -2);\n            flex-direction: column;\n            \n            & ").concat(LeftArrow, " {\n                transform: rotate(90deg) translate(0, -100%);\n                transform-origin: 0 0;\n            }\n            \n            & ").concat(RightArrow, " {\n                bottom: calc(").concat(distance, " / -2);\n                transform: rotate(90deg) scaleX(-1);\n                transform-origin: 0 100%;\n            }\n        ") : "\n            width: calc(100% + ".concat(distance, ");\n            top: calc(50% - ").concat(height, " / 2);\n            left: calc(").concat(distance, " / -2);\n            margin-top: -30px;\n        ");
});

var ArrowWrap = _styledComponents["default"].div.withConfig({
  displayName: "arrows__ArrowWrap",
  componentId: "sc-1xfaeh9-3"
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    pointer-events: auto;\n    visibility: ", ";\n"])), function (p) {
  return p.isHide ? 'hidden' : 'visible';
});

var DefaultArrows = /*#__PURE__*/function (_React$Component) {
  _inherits(DefaultArrows, _React$Component);

  var _super = _createSuper(DefaultArrows);

  function DefaultArrows() {
    var _this;

    _classCallCheck(this, DefaultArrows);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "parameterToStyle", function (parameter) {
      return isNaN(parameter) ? parameter : "".concat(parameter, "px");
    });

    return _this;
  }

  _createClass(DefaultArrows, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          swipeLeft = _this$props.swipeLeft,
          swipeRight = _this$props.swipeRight,
          visibleCardWidth = _this$props.visibleCardWidth,
          _this$props$vertical = _this$props.vertical,
          vertical = _this$props$vertical === void 0 ? false : _this$props$vertical,
          _this$props$hideLeftA = _this$props.hideLeftArrow,
          hideLeftArrow = _this$props$hideLeftA === void 0 ? false : _this$props$hideLeftA,
          _this$props$hideRight = _this$props.hideRightArrow,
          hideRightArrow = _this$props$hideRight === void 0 ? false : _this$props$hideRight,
          _this$props$config = _this$props.config,
          _this$props$config$wi = _this$props$config.width,
          width = _this$props$config$wi === void 0 ? 'fit-content' : _this$props$config$wi,
          _this$props$config$he = _this$props$config.height,
          height = _this$props$config$he === void 0 ? 30 : _this$props$config$he,
          _this$props$config$di = _this$props$config.distance,
          distance = _this$props$config$di === void 0 ? 60 : _this$props$config$di;
      return /*#__PURE__*/_react["default"].createElement(Container, {
        visibleCardWidth: visibleCardWidth,
        vertical: vertical,
        height: this.parameterToStyle(height),
        distance: this.parameterToStyle(distance)
      }, /*#__PURE__*/_react["default"].createElement(ArrowWrap, {
        isHide: hideLeftArrow
      }, /*#__PURE__*/_react["default"].createElement(LeftArrow, {
        key: "left",
        src: _arrow["default"],
        onClick: swipeLeft,
        height: this.parameterToStyle(height),
        width: this.parameterToStyle(width)
      })), /*#__PURE__*/_react["default"].createElement(ArrowWrap, {
        isHide: hideRightArrow
      }, /*#__PURE__*/_react["default"].createElement(RightArrow, {
        key: "right",
        src: _arrow["default"],
        onClick: swipeRight,
        height: this.parameterToStyle(height),
        width: this.parameterToStyle(width),
        distance: this.parameterToStyle(distance)
      })));
    }
  }]);

  return DefaultArrows;
}(_react["default"].Component);

var _default = DefaultArrows;
exports["default"] = _default;